import { render } from "./DistributorRoutingPage.vue?vue&type=template&id=5a327a8a&scoped=true"
import script from "./DistributorRoutingPage.vue?vue&type=script&lang=js"
export * from "./DistributorRoutingPage.vue?vue&type=script&lang=js"

import "./DistributorRoutingPage.vue?vue&type=style&index=0&id=5a327a8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a327a8a"]])

export default __exports__